import { createStyles, Skeleton, Flex } from '@mantine/core';

import ContestNotificationWidget from '~/domains/contest/domains/common/components/ContestNotificationWidget/ContestNotificationWidget';
import {
  useIsBiggerThanMobile,
  useIsBiggerThanNotebook,
} from '~/domains/common/hooks/mediaQueries';

import { useHomeGroupInvites } from '../hooks/useHomeGroupInvites';
import { useHomeInvites } from '../hooks/useHomeInvites';
import { useHomeNotifications } from '../hooks/useHomeNotifications';
import { useHomeOffers } from '../hooks/useHomeOffers';
import { useHomeRestarts } from '../hooks/useHomeRestarts';

import HomeGroupInviteWidget from './HomeGroupInviteWidget';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    width: '100%',
    gap: theme.other.spacing._16,
    alignItems: 'start',

    [theme.fn.smallerThan('lg')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
}));

function HomeWidgets({ order }: { order: number }) {
  const { notificationsProps, isNotificationsLoading } = useHomeNotifications();
  const { offersProps, isOffersLoading } = useHomeOffers();
  const { restartsProps, isRestartsLoading } = useHomeRestarts();
  const { groupInvitesProps, isGroupInvitesLoading } = useHomeGroupInvites();
  const { invitesProps, isInvitesLoading } = useHomeInvites();

  const isBiggerThanMobile = useIsBiggerThanMobile();
  const isBiggerThanNotebook = useIsBiggerThanNotebook();
  const { classes } = useStyles();

  const isFullWidth = isBiggerThanMobile && !isBiggerThanNotebook;

  const noNotifications = !isNotificationsLoading && !notificationsProps;
  const noOffers = !isOffersLoading && !offersProps;
  const noRestarts = !isRestartsLoading && !restartsProps;
  const noGroupInvites = !isGroupInvitesLoading && !groupInvitesProps;
  const noInvites = !isInvitesLoading && !invitesProps;

  if (noNotifications && noOffers && noRestarts && noGroupInvites && noInvites) return null;

  return (
    <Flex
      direction="column"
      style={{ order }}
      /* eslint-disable-line local-rules/use-theme-tokens */ gap={16}
    >
      {/* Contest notification widgets */}
      <div className={classes.container}>
        {isNotificationsLoading && !notificationsProps ? (
          <Skeleton height={54} />
        ) : (
          notificationsProps && (
            // @ts-expect-error @TODO: update types to match the new widget
            <ContestNotificationWidget {...notificationsProps} isFullWidth={isFullWidth} />
          )
        )}
        {isOffersLoading && !offersProps ? (
          <Skeleton height={54} />
        ) : (
          offersProps && <ContestNotificationWidget {...offersProps} isFullWidth={isFullWidth} />
        )}
        {isRestartsLoading && !restartsProps ? (
          <Skeleton height={54} />
        ) : (
          restartsProps && (
            <ContestNotificationWidget {...restartsProps} isFullWidth={isFullWidth} />
          )
        )}
        <HomeGroupInviteWidget isFullWidth={isFullWidth} />
        {isInvitesLoading && !invitesProps ? (
          <Skeleton height={54} />
        ) : (
          invitesProps && <ContestNotificationWidget {...invitesProps} isFullWidth={isFullWidth} />
        )}
      </div>
    </Flex>
  );
}

export default HomeWidgets;
